let elements = document.querySelectorAll(".Ma-text");
elements.forEach((element) => {
  let innerText = element.innerText;
  element.innerHTML = "";
  let textContainer = document.createElement("div");
  textContainer.classList.add("block");
  for (let letter of innerText) {
    let span = document.createElement("span");
    span.innerText = letter.trim() === "" ? "\xa0" : letter;
    span.classList.add("letter");
    textContainer.appendChild(span);
  }
  element.appendChild(textContainer);
  element.appendChild(textContainer.cloneNode(true));
});
elements.forEach((element) => {
  element.addEventListener("mouseover", () => {
    element.classList.remove("play");
  });
});

document.querySelectorAll('.Ma-faq').forEach(faq => {
    faq.addEventListener('click', function() {
        const faqContent = faq.nextElementSibling; 
        faqContent.classList.toggle('is-open'); 
        const heading = faq.querySelector('h2');
        heading.classList.toggle('is-active'); 
    });
});

 function updateSelectedCount() {
    const checkboxes = document.querySelectorAll('.MA-checkbox');
    const selectedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
    const messageElement = document.getElementById('selected-count-message');
    if (selectedCount > 0) {
      messageElement.textContent = `${selectedCount}  tilbehør er valgt`;
    } else {
      messageElement.textContent = '';
    }
  }
  document.querySelectorAll('.MA-checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', updateSelectedCount);
  });
  updateSelectedCount();


// Delivery Code
var currentDate = new Date();
var day = currentDate.getDay();
var hour = currentDate.getHours();
var options = { weekday: "long", day: "numeric", month: "long" };
var deliveryDateText = "";

function getNextWorkingDay(date) {
  let nextDate = new Date(date);
  do {
    nextDate.setDate(nextDate.getDate() + 1);
  } while (nextDate.getDay() === 6 || nextDate.getDay() === 0); // Skip Saturday and Sunday
  return nextDate;
}

function calculateDeliveryDate(orderDate, daysToAdd) {
  let deliveryDate = new Date(orderDate);
  for (let i = 0; i < daysToAdd; i++) {
    deliveryDate = getNextWorkingDay(deliveryDate);
  }
  return deliveryDate;
}

if (day === 0 || day === 6) {
  // Weekend orders are shipped on Monday
  let nextMonday = getNextWorkingDay(currentDate);
  let deliveryDate = calculateDeliveryDate(nextMonday, 2);
  deliveryDateText = `${deliveryDate.toLocaleDateString("da-DK", options)}`;
} else if (hour < 12) {
  // Orders placed before 12:00 PM
  let shippingDate = currentDate;
  let deliveryDate = calculateDeliveryDate(shippingDate, 2);
  deliveryDateText = `${deliveryDate.toLocaleDateString("da-DK", options)}`;
} else {
  // Orders placed after 12:00 PM
  let shippingDate = getNextWorkingDay(currentDate);
  let deliveryDate = calculateDeliveryDate(shippingDate, 2);
  deliveryDateText = `${deliveryDate.toLocaleDateString("da-DK", options)}`;
}

document.querySelectorAll('.Ma-calculated-date').forEach(span => {span.innerText = deliveryDateText;})


//Product Link Texts
document.addEventListener("DOMContentLoaded", () => {
  const summarySection = document.querySelector(".summaryss");
  const initialOffsetTop = summarySection.offsetTop; // Original position

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;

    if (scrollY >= initialOffsetTop) {
      summarySection.classList.add("sticky");
    } else {
      summarySection.classList.remove("sticky");
    }
  });

  document.querySelectorAll('.scroll-link').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            const offset = 100;
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: targetPosition - offset,
                behavior: 'smooth'
            });
        }
    });
  });
});


document.querySelectorAll('slider-component').forEach((sliderComponent) => {
  const slider = sliderComponent.querySelector('.grid');
  const progressBarFill = sliderComponent.querySelector('.swiper-pagination-progressbar-fill');

  if (slider && progressBarFill) {
  
    slider.addEventListener('scroll', () => {

      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      console.log("maxScrollLeft:", maxScrollLeft); // Debugging output

      const scrollLeft = slider.scrollLeft;
      const scrollPercentage = scrollLeft / maxScrollLeft;
      console.log("scrollPercentage:", scrollPercentage); // Debugging output

      const scaleValue = 0.20 + (0.80* scrollPercentage);
      console.log("scaleValue:", scaleValue); // Debugging output

      progressBarFill.style.transform = `scaleX(${scaleValue})`;
    });
  } else {
    console.log("Slider or progress bar not found."); // Debugging output
  }
});

const days = [
  "Søndag",
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
];
const monthNames = [
  "januar",
  "februar",
  "marts",
  "april",
  "maj",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "december",
];

const now = new Date();
const future = new Date();
future.setHours(now.getHours() + 11);

let hours = 23 - future.getHours();
let min = 60 - future.getMinutes();
let sec = 60 - future.getSeconds();
min = min < 10 ? "0" + min : min;
sec = sec < 10 ? "0" + sec : sec;
// document.querySelector(".timer").innerHTML = hours + " timer " + min + " min " + sec + " sek";4

const deliveryDate = new Date(now);
const currentDay = now.getDay();
const currentHour = now.getHours();

if (currentDay >= 1 && currentDay <= 4) {
  deliveryDate.setDate(deliveryDate.getDate() + (currentHour < 14 ? 1 : 2));
  if (deliveryDate.getDay() === 6) {
    deliveryDate.setDate(deliveryDate.getDate() + 2);
  } else if (deliveryDate.getDay() === 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }
} else if (currentDay === 5) {
  deliveryDate.setDate(deliveryDate.getDate() + 3);
} else if (currentDay === 6) {
  deliveryDate.setDate(deliveryDate.getDate() + 2);
} else {
  deliveryDate.setDate(deliveryDate.getDate() + 1);
}

document.querySelector(".estimated-delivery span").innerHTML =
  days[deliveryDate.getDay()] + ", " + deliveryDate.getDate() + ". " + monthNames[deliveryDate.getMonth()];



